export default "__VITE_ASSET__W2doWUeg__"